export default "__VITE_ASSET__8a4988a3__"